export default __webpack_public_path__ + "static/media/icon_book_caligrafix_platform.65f86748.svg";